//#region Dependencias
import React, { Component } from "react";
import "../css/dataTables.css";
import $ from "jquery";
import moment from "moment";
//#endregion

const getDocumentType = (DocType) => {
    switch (DocType) {
        case 198: return "Demanda prevista";
        case 199: return "Solicitud de compra";
        default: return "";
    }
}

const getRemarks = (DocType) => {
    switch (DocType) {
        case 198: return "Fuente de documento";
        case 199: return "Recomenación";
        default: return "";
    }
}

class StandardSelectModal extends Component {
    closeModal = () => {
        $("#PeggingInformationModal").modal("hide");
    };

    //#region Render
    render() {
        const {
            filters,
            docs,
        } = this.props;

        return (
            <div>
                <div
                    className="modal fade bd-example-modal-md modal-open scroll"
                    id="PeggingInformationModal"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true">
                    <div className="modal-dialog modal-md modal-open" role="document">
                        <div className="modal-content">
                            <div className="modal-header text-white" style={{ backgroundColor: "#343a40", borderRadius: "0" }}>
                                <h4 className="modal-title" id="modal-basic-title "> Documentos Relacionados </h4>
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">
                                        &times;
                                    </span>
                                </button>
                            </div>
                            <div className="modal-body" >
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text"> Artículo </span>
                                                </div>
                                                <span className="form-control"> {filters.ItemCode || ""} </span>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text"> Descripción </span>
                                                </div>
                                                <span className="form-control"> {filters.ItemName || ""} </span>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text"> Periodo </span>
                                                </div>
                                                <span className="form-control text-right"> {filters.StartDate || "DD/MM/YYYY"} - {filters.EndDate || "DD/MM/YYYY"} </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <table className="table table-scroll" style={{ fontSize: 14 }} id="bodyModal" >
                                            <div
                                                className="w-100"
                                                aria-labelledby="nav-home-tab-Contenido"
                                                style={{ minHeight: 300, maxHeight: 350 }}>
                                                <table
                                                    id="dataTableDocuments"
                                                    className="display" >
                                                    <thead className="table-header-yellow">
                                                        <tr style={{ backgroundColor: '#d2ab24', textAlign: 'left' }}>
                                                            <th className="p-2 border"> Tipo </th>
                                                            <th className="p-2 border"> Fecha de vencimiento </th>
                                                            <th className="p-2 border"> Cantidad </th>
                                                            <th className="p-2 border"> Almacén </th>
                                                            <th className="p-2 border"> Comentarios </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {docs.map((doc, index) =>
                                                            <tr key={index}>
                                                                <th className="p-2 border"> {getDocumentType(Number(doc.BaseObj))} </th>
                                                                <th className="p-2 border"> {moment(doc.BaseDue).format("DD/MM/YYYY")} </th>
                                                                <th className="p-2 border"> {Number(doc.Quantity || 0).toFixed(3)} </th>
                                                                <th className="p-2 border"> {doc.WhsCode} </th>
                                                                <th className="p-2 border"> {getRemarks(Number(doc.BaseObj))} </th>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeModal} >Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    //#endregion
}

export default StandardSelectModal;